// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"cea4a3a6","364":"de4d2676","400":"eff0345b","980":"1690912c"}[chunkId] + ".chunk.js";
};